const firebaseConfig = {
    apiKey: "AIzaSyDJbLkB7XefkFVg1prJ1P6icg6qXSyml1M",
    authDomain: "yoga-campus.firebaseapp.com",
    projectId: "yoga-campus",
    storageBucket: "yoga-campus.appspot.com",
    messagingSenderId: "104307383423",
    appId: "1:104307383423:web:3dc049138c73d47423f34a"
};

export default firebaseConfig;